import NextImage from 'next/legacy/image'
import Link from 'next/link'
import type { FunctionComponent } from 'react'
import { InternalLink } from '../../const/Links'
import { Translation, useTranslate } from '../../contexts/TranslationContext'
import { Button } from '../shared/Button'
import style from './HesitateBanner.module.sass'

type HesitateBannerProps = {
	slug: string
	title: string
}
export const HesitateBanner: FunctionComponent<HesitateBannerProps> = ({ slug, title }) => {
	const translate = useTranslate()

	return (
		<Link href={`${InternalLink.BlogPost}${slug}`} title={title}>
			<div className={style.wrapper}>
				<div className={style.content}>
					<div className={style.header}>
						<h2 className={style.title}>
							<Translation tr="hesitateBanner.title" />
						</h2>
					</div>
					<div className={style.subtitle}>
						<span>
							<Translation tr="hesitateBanner.subtitle.first" />
							<br />
							<Translation tr="hesitateBanner.subtitle.second" />
						</span>{' '}
						<span className={style.buttonWrapper}>
							<Button type={{ variant: 'underlined' }} label={title} />
						</span>
					</div>
				</div>
				<div className={style.imagesGroup}>
					<div className={style.imageWrapper}>
						<NextImage
							src="/images/FoodAndPuppies.png"
							alt={translate('hesitateBanner.alt.image.puppies')}
							title={translate('hesitateBanner.alt.image.puppies')}
							layout="fill"
							objectFit="contain"
						/>
					</div>
				</div>
			</div>
		</Link>
	)
}
